export const headerStylings = {
  filingTabs: { marginLeft: '1.9rem', marginBottom: '1rem' },
  filingTab: {
    minWidth: 110,
    textTransform: 'none',
    color: '#0A2F6A',
    borderRadius: '8px 8px 0 0',
    '&:focus:not(:focus-visible)': { outline: 'none' },
    '&:focus-visible': { outline: '2px solid #0A2F6A', outlineOffset: -2 },
  },
  filingMain: { backgroundColor: '#FFF5D9' },
  filingAmended: { backgroundColor: '#DCFAF8' },
  filingExtension: { backgroundColor: '#E7EDFF' },
  filingNotice: { marginLeft: '1.9rem', marginBottom: '1rem', color: '#646F78' },
  mainHeader: {
    color: '#0A2F6A',
    fontFamily: 'Inter, sans-serif',
    fontSize: '1.75rem',
    fontStyle: 'normal',
    fontWeight: 575,
    lineHeight: 'normal',
    marginLeft: '1.9rem',
    display: 'flex',
    marginBottom: '.3rem',
    letterSpacing: '0.045em',
  },
  subHeaderText: {
    fontFamily: 'Inter, sans-serif',
    marginLeft: '1.9rem',
    color: '#646F78',
    fontSize: '1rem',
    fontWeight: '500',
    display: 'flex',
  },
};

const baseCard = {
  fontSize: '1.875rem',
  width: '13.5rem',
  height: '7rem',
  alignSelf: 'stretch',
  background: '#FCFCFC',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '1rem',
  boxShadow: '0px 2px 4px rgba(0,0,0,0.18)',
  overflow: 'hidden',
};

export const statCardStyling = {
  wrapper: {
    marginTop: '1.5rem',
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  content: {
    width: '100%',
    height: '100%',
    minHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    padding: '8px 16px',
    borderRadius: 'inherit',
  },
  actionArea: {
    '&:hover': { backgroundColor: 'rgba(10, 47, 106, 0.04)' },
  },
  focusVisible: {
    // Inset ring stays visible inside the Paper's clipped, rounded edges.
    boxShadow: 'inset 0 0 0 3px #0A2F6A',
  },
  actionCue: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginTop: 4,
    color: '#0A2F6A',
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: '20px',
  },
  arrow: { fontSize: 16 },
  statCardSmall: {
    ...baseCard,
    minWidth: '8.75rem',
    width: 'auto',
  },
  statCard: {
    ...baseCard,
    minWidth: '12.5rem',
    width: 'auto',
  },
  statCardLarge: {
    ...baseCard,
    minWidth: '14.5rem',
    width: 'auto',
  },
  statCardOverview: {
    ...baseCard,
    width: '100%',
    minWidth: 0,
    height: 'auto',
    minHeight: '8rem',
  },
};

export const gridStyling = {
  section: { marginTop: 32 },
  // Styling for entire widget layout - may not need
  dashboardGrid: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2rem',
    display: 'flex',
  },
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '2rem',
    marginLeft: '1.8rem',
  },
};

export const metricTileStyling = {
  count: {
    fontSize: '1.775rem',
    fontWeight: 450,
    color: '#232323',
    textAlign: 'center',
  },
  overviewCount: {
    fontSize: '1.875rem',
    fontWeight: 550,
    color: '#232323',
    textAlign: 'center',
    //  marginRight: '1.25rem',
  },
  label: {
    fontSize: '1.125rem',
    marginLeft: '1rem',
    color: '#2D4C7E',
  },
  widgetLabel: {
    fontSize: '1.125rem',
    color: '#2D4C7E',
    textAlign: 'center',
  },
  subLabel: {
    fontSize: '0.95rem',
    color: '#646F78',
    marginLeft: '.5rem',
  },
  summaryContent: {
    display: 'flex',
    alignItems: 'center',
    padding: 16,
  },

  genericIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 50,
  },

  textContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
};

export const topMenuTypography = {
  color: '#67727C',
  fontFamily: 'Roboto',
  fontSize: '0.85444rem',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: 'normal',
  letterSpacing: '0.00588rem',
};
